<style>
    .tvl_layer a, .tvl_layer a:hover {
        text-decoration: none !important
    }

    .tvl_layer div {
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .tvl_layer_mask {
        position: fixed;
        z-index: 998;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0)
    }

    .tvl_layer {
        position: fixed;
        z-index: 999;
        left: 0;
        bottom: 0;
        width: 100%;
        background: rgba(0, 0, 0, .8)
    }

    .tvl_layer .tvl_bd {
        padding: 16px 20px 0
    }

    .tvl_layer .tvl_login_tit {
        font-size: 15px;
        line-height: 30px;
        color: #fff;
        text-align: center;
        margin-bottom: 8px
    }

    .tvl_layer .tvl_login_btn {
        padding: 0 42px 3px
    }

    .tvl_layer .tvl_login_wx, .tvl_layer .tvl_login_qq {
        display: block;
        width: 100%;
        text-align: center;
        line-height: 38px;
        font-size: 14px;
        color: #fff;
        border-radius: 19px;
        margin-bottom: 15px
    }

    .tvl_layer .tvl_login_wx {
        background: #2ec637
    }

    .tvl_layer .tvl_login_qq {
        background: #40a5e5
    }

    .tvl_layer .tvl_icon_wx, .tvl_layer .tvl_icon_qq {
        display: inline-block;
        width: 25px;
        height: 21px;
        background-image: url(//vm.gtimg.cn/tencentvideo/vstyle/mobile/vip/style/app_v2/img/tvl_layer/sprite_icon.png?d=0623&max_age=31104000);
        background-repeat: no-repeat;
        background-position: 9999em 9999em;
        background-size: 60px;
        vertical-align: middle;
        margin-right: 4px;
        position: relative;
        top: -2px
    }

    .tvl_layer .tvl_icon_wx {
        background-position: 0 0
    }

    .tvl_layer .tvl_icon_qq {
        background-position: -30px 0
    }

    .tvl_layer .tvl_btn {
        position: relative;
        overflow: hidden
    }

    .tvl_layer .tvl_btn:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        border-bottom: 1px solid #3f4041;
        -webkit-transform: scaleY(.5);
        -webkit-transform-origin: 0 0
    }

    .tvl_layer .tvl_btn_a, .tvl_layer .tvl_btn_b {
        position: relative;
        float: left;
        display: block;
        width: 100%;
        font-size: 15px;
        line-height: 50px;
        text-align: center
    }

    .tvl_layer .tvl_btn_a {
        color: #fff
    }

    .tvl_layer .tvl_btn_b {
        color: #bf954b
    }

    .tvl_layer .tvl_btn_2 .tvl_btn_a, .tvl_layer .tvl_btn_2 .tvl_btn_b {
        width: 50%
    }

    .tvl_layer .tvl_btn_2 .tvl_btn_b:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        border-left: 1px solid #3f4041;
        -webkit-transform: scaleX(.5);
        -webkit-transform-origin: 0 0
    }


</style>
<template>
    <div class="tvl_layer tvl_layer_login" v-if="state">
        <div class="tvl_bd">
            <div class="tvl_login">
                <div class="tvl_login_tit">{{title}}</div>
                <div class="tvl_login_btn">
                    <a class="tvl_login_qq" href="javascript:;" @click="loginByQQ"><i class="tvl_icon_qq"></i>QQ登录</a>
                    <a class="tvl_login_wx" href="javascript:;" @click="loginByWx"><i class="tvl_icon_wx"></i>微信登录</a>
                </div>
            </div>
            <div class="tvl_btn">
                <a class="tvl_btn_a" href="javascript:;" @click="hide">取     消</a>
            </div>
        </div>
    </div>
</template>
<script>

    import login from '@tencent/vft-common/login'

    var loginPopState = {
        title: '选择你要登录的帐号类型',
        state: false
    };

    export default {
        data() {
            return loginPopState
        },
        methods: {
            hide(){
                loginPopState.state = false;
            },
            loginByQQ () {
                login.openLogin({
                    type: 'qq'
                })
                return false
            },
            loginByWx () {
                login.openLogin({
                    type: 'wx'
                })
                return false
            },
        },
        install(Vue){

            Vue.prototype.openLogin = function (title = '选择你要登录的帐号类型') {
                loginPopState.state = true;
                loginPopState.title = title;

            }

            Vue.prototype.closeLogin = function () {
                loginPopState.state = false;
            }


        }
    }


</script>
